export const COMPANY_PARTICIPANT_ROLE = 'company_participant'
export const COMPANY_PARTICIPANT_NAME_KEY = 'company-participant-name'

export function isCandidateForQuestionSession(attributes: Record<string, string> = {}): boolean {
  return attributes.role !== COMPANY_PARTICIPANT_ROLE && attributes.isAdmin !== 'true' &&
    attributes.isCurator !== 'true' && (attributes.phone || '').replace(/\D/g, '').length === 11
}

export function getParticipantInvitation(query: Record<string, unknown>): string | undefined {
  return typeof query.participantInvite === 'string' && query.participantInvite.length > 0
    ? query.participantInvite : undefined
}

export function normalizeParticipantName(value: unknown): string {
  return typeof value === 'string' ? value.replace(/[:\r\n\t]/g, ' ').trim().slice(0, 100) : ''
}
